import React, { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown, DropdownButton } from "react-bootstrap"

import { httpOk, GET, POST, PUT } from 'helpers/api'
import { formatDate } from "helpers/helpers"

function Index() {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const [data, setData] = useState([])
	const [loyaltyTypes, setLoyaltyTypes] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [modalManual, setModalManual] = useState(false)
	const [modalRegistration, setModalRegistration] = useState(false)

	async function createUpdateRegistration(e) {
		e.preventDefault()

		var response
		if (!selectedItem.id) {
			response = await POST('/loyalty/services-registration', selectedItem, { loader: true })
		} else {
			response = await PUT('/loyalty/services-registration', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			toggleModalRegistration()
		}
	}

	async function createUpdateManual(e) {
		e.preventDefault()

		var response
		if (!selectedItem.id) {
			response = await POST('/loyalty/services-manual', selectedItem, { loader: true })
		} else {
			response = await PUT('/loyalty/services-manual', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			toggleModalManual()
		}
	}

	async function handleChangeStatus(e, type, index, id) {
		//var dataCopy = JSON.parse(JSON.stringify(data))

		var sendDta = {
			"id": id,
			"status": e.target.checked,
		}

		await PUT('/loyalty/services-status', sendDta, { loader: true })
		searchWithFilter()
	}

	function goTo(item) {
		if (item.id === 1) {
			navigate('/loyalty/services/create-amount')
			return
		}

		if (item.id === 2) {
			navigate('/loyalty/services/create-saving')
			return
		}

		if (item.id === 3) {
			navigate('/loyalty/services/create-visit')
			return
		}

		if (item.id === 4) {
			toggleModalRegistration(true)
			return
		}

		if (item.id === 5) {
			toggleModalManual(true)
			return
		}
	}

	function toggleModalRegistration(bool = false, item = {}) {
		setSelectedItem(item)
		setModalRegistration(bool)
	}

	function toggleModalManual(bool = false, item = {}) {
		setSelectedItem(item)
		setModalManual(bool)
	}

	async function searchWithFilter() {
		const response = await GET('/loyalty/services', {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	async function getLoyaltyServiceTypes() {
		const response = await GET('/helper/loyalty-service-types', {}, { loader: true })
		if (httpOk(response)) setLoyaltyTypes(response.data)
	}

	useEffect(() => {
		searchWithFilter()
		getLoyaltyServiceTypes()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('loyalty')} [{data.length}]
				</h4>
				<div className="d-flex">
					<DropdownButton title={t('action')}>
						{loyaltyTypes.map((item, index) => (
							<Dropdown.Item key={index}
								onClick={() => goTo(item)}>
								{item.name}
							</Dropdown.Item>
						))}
					</DropdownButton>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }} >{t('name2')}</th>
									<th style={{ 'width': '15%' }} >{t('type')}</th>
									<th style={{ 'width': '15%' }} >{t('launch_date')}</th>
									<th style={{ 'width': '15%' }} >{t('stop_date')}</th>
									<th style={{ 'width': '10%' }} className="text-center text-nowrap">{t('status')}</th>
									<th style={{ 'width': '25%' }}></th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>{item.name}</td>
										<td>{item.service_name}</td>
										<td>{formatDate(item.start_at, 'dd.MM.yy HH:mm')}</td>
										<td>{formatDate(item.stop_at, 'dd.MM.yy HH:mm')}</td>
										<td>
											<div className="form-check form-switch form-switch-md justify-content-center">
												<input type="checkbox" className="form-check-input" name="status"
													checked={item.status}
													onChange={(e) => handleChangeStatus(e, 'checkbox', index, item.id)} />
											</div>
										</td>
										<td></td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														{item.loyalty_service_type_id === 1 &&
															<Link to={`/loyalty/services/update-amount/${item.id}`} className="table-dropdown-item">
																<i className="uil-edit-alt"></i>
																{t('edit')}
															</Link>
														}
														{item.loyalty_service_type_id === 2 &&
															<Link to={`/loyalty/services/update-saving/${item.id}`} className="table-dropdown-item">
																<i className="uil-edit-alt"></i>
																{t('edit')}
															</Link>
														}
														{item.loyalty_service_type_id === 3 &&
															<Link to={`/loyalty/services/update-visit/${item.id}`} className="table-dropdown-item">
																<i className="uil-edit-alt"></i>
																{t('edit')}
															</Link>
														}
														{item.loyalty_service_type_id === 4 &&
															<div className="table-dropdown-item"
																onClick={() => toggleModalRegistration(true, item)}>
																<i className="uil-edit-alt"></i>
																{t('edit')}
															</div>
														}
														{item.loyalty_service_type_id === 5 &&
															<div className="table-dropdown-item"
																onClick={() => toggleModalManual(true, item)}>
																<i className="uil-edit-alt"></i>
																{t('edit')}
															</div>
														}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL REGISTRATION */}
			<Modal show={modalRegistration} animation={false} centered
				onHide={() => toggleModalRegistration()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdateRegistration} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}</label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name}
								autoFocus
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>

						<div className="form-group">
							<label>{t('amount')}</label>
							<input type="text" className="form-control" name="amount"
								value={selectedItem.amount}
								autoFocus
								onChange={(e) => setSelectedItem({ ...selectedItem, 'amount': e.target.value.replace(/[^0-9]/gi, '') })} />
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalRegistration()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL REGISTRATION */}

			{/* MODAL MANUAL */}
			<Modal show={modalManual} animation={false} centered
				onHide={() => toggleModalManual()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdateManual} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}</label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name}
								autoFocus
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>

						<div className="form-group">
							<label>{t('max')}</label>
							<input type="text" className="form-control" name="max_amount"
								value={selectedItem.max_amount}
								autoFocus
								onChange={(e) => setSelectedItem({ ...selectedItem, 'max_amount': e.target.value.replace(/[^0-9]/gi, '') })} />
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalManual()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL MANUAL */}
		</>
	)
}

export default Index